import { bl_ppl_ap_validation_test_file_zip_hdr_RowClass } from '../../../dbschema/bl_ppl_ap_validation_test_file_zip_hdr.model';
import { BaseContainerModel } from '../../base-container.model';

export class PeppolAPTestbedValidationTestFileZipContainerModel extends BaseContainerModel {
    bl_ppl_ap_validation_test_file_zip_hdr: bl_ppl_ap_validation_test_file_zip_hdr_RowClass = new bl_ppl_ap_validation_test_file_zip_hdr_RowClass();
}